const Auth = {
    isAuthenticated: false,
    authenticate() {
        this.isAuthenticated = true;
    },
    signout() {
        this.isAuthenticated = false;
    },
    getAuth() {
        return this.isAuthenticated;
    }
};
export default Auth;

let currentRoute =window.location.pathname;
export let getcurrentRoute= () => currentRoute;
const userRole = sessionStorage.getItem('UserType');


export const getUserRole = () => userRole;

const Permissions = JSON.parse(sessionStorage.getItem('Permissions'));


export const getPermissions = () => Permissions;
 export const checkPermission=(arr1)=>{
    let dashboardObject = {
      Category: "Admin",
      CreatedBy: 106,
      CreatedDate: "2025-08-28T08:59:06.627",
      DeletedBy: 0,
      DeletedDate: "0001-01-01T00:00:00",
      ID: 49,
      IsDeleted: false,
      Message: null,
      Permission: "Dasboard",
      PermissionKey: "Dashboard",
      UpdatedBy: 0,
      UpdatedDate: "0001-01-01T00:00:00",
      UserId: 2382,
    };
 let perm=JSON.parse(sessionStorage.getItem('Permissions'));
 perm.push(dashboardObject)
 console.log('klk',perm)
if(perm !=null || perm!=undefined)
{
    
for (let perms of perm) {
     
    
    if (arr1===perms.PermissionKey){
     
      return true;
    }
  }

  return false; // No common element found
}
 
} 